import React, { useState } from "react";
import Alert from "./GxAlert";

/**
 * راهنمای قابل‌بستن — فقط بار اول نمایش داده می‌شود (localStorage).
 * props: id (کلید یکتا)، message، description، type (پیش‌فرض info)
 */
export default function DismissibleHelp({ id, message, description, type = "info", style }) {
  const storageKey = `help-dismissed-${id}`;
  const [hidden, setHidden] = useState(() => localStorage.getItem(storageKey) === "1");

  if (hidden) return null;

  return (
    <Alert
      type={type}
      message={message}
      description={description}
      showIcon
      closable
      onClose={() => {
        localStorage.setItem(storageKey, "1");
        setHidden(true);
      }}
      style={{ marginBottom: 12, ...style }}
    />
  );
}
